<template>
	<div class="mxinBrandCo">
		<div class="menuBox">
			<div class="menuImgBox" @click="open">
				<img class="menuImg" src="../../assets/mImg/menuIcon.png" alt="">
			</div>
			<div class="lansuImgBox">
				<img class="lansuImg" src="../../assets/logo2.png" alt="">
			</div>
			<!-- <div class="blackBox"></div> -->
		</div>
		<div class="firstBox">
			<img class="mFirst" src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-06-20_16-26-38_48364.png">
			<!-- <div class="mFirstBox">
				<div class="mFirstBoxImgBox" @click="enterProducts(2)">
					<img class="mFirstBoxImg" src="../../assets/xqtTopNew.png" alt="">
				</div>
			</div> -->
		</div>

		<el-drawer class="drawerBox" :visible.sync="drawer" :direction="direction" :before-close="handleClose"
			unique-opened>
			<el-menu :default-active="this.$route.path" class="el-menu-vertical-demo" @open="handleOpen"
				@close="handleCloseMenu" router>
				<el-menu-item index="/m">
					<i class="el-icon-s-home"></i>
					<span slot="title">首页</span>
				</el-menu-item>
				<el-menu-item index="/maboutLansu">
					<i class="el-icon-document"></i>
					<span slot="title">关于我们</span>
				</el-menu-item>
				<el-menu-item index="/mbrandLansu">
					<i class="el-icon-data-analysis"></i>
					<span slot="title">美业菩提</span>
				</el-menu-item>
				<el-menu-item index="/mDynamicLanshu">
					<i class="el-icon-star-off"></i>
					<span slot="title">菩提基金会</span>
				</el-menu-item>
				<el-submenu index="5">
					<template slot="title">
						<i class="el-icon-trophy"></i>
						<span>兰树品牌</span>
					</template>
					<el-menu-item-group>
						<el-menu-item index="/mhuaibrand">淮树</el-menu-item>
						<el-menu-item index="/mxinbrand">心清堂</el-menu-item>
						<el-menu-item index="/mshuibrand">水姻缘</el-menu-item>
						<el-menu-item index="/myibrand">一清堂</el-menu-item>
						<!-- <el-menu-item index="/mzhongbrand"><span>Dr.CHUNG<span style="vertical-align: super;">+</span></span></el-menu-item> -->
						<el-menu-item index="/mlanshuBrand">兰树</el-menu-item>
						<el-menu-item index="/mzbqfBrand">植本清方</el-menu-item>
					</el-menu-item-group>
				</el-submenu>
				<el-menu-item index="/mTrends">
					<i class="el-icon-bell"></i>
					<span slot="title">兰树动态</span>
				</el-menu-item>
			</el-menu>

		</el-drawer>

		<div class="secondBox">
			<!-- <div class="pageTopTitle">系列</div> -->
			<img class="mFirst" src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-06-20_16-27-16_92560.png">
			<!-- <div class="mSecondTitleBox">
				心清堂品牌系列产品
			</div> -->


			<!-- <wc-swiper class="swiperItemBox">
				<wc-slide v-for="(item,index) in series" :key="index" >
					<div class="seriesImg">
						<img :src="item.img" alt="">
					</div>
				</wc-slide>
			</wc-swiper> -->
		</div>

		

		<div class="thirdBox">
			<img class="mFirst4" src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-08-18_13-52-58_90348.jpg" alt="">
			<!-- <div class="thirdBoxItem">
				<div class="pageTopTitle">品牌特色</div>
				<div class="thirdBoxItemMain">
					<div class="thirdBoxItemMainLeft">
						<img class="thirdBoxItemMainLeftImg" src="../../assets/brand/t-brandBgItem.png" alt="">
					</div>
					<div class="thirdBoxItemMainRight">
						<div class="thirdBoxItemMainRightTop">
							<div class="cavas">草本</div>
							<div class="cavas">养护</div>
							<div class="cavas">科技</div>
						</div>
						<div class="thirdBoxItemMainRightTitle">
							用科技赋能美业，潜心打造安全性、功效性、针对性强的护肤产品。
						</div>
					</div>
				</div>
			</div> -->
		</div>

		<div class="forthBox">
			<img class="mFirst4" src="../../assets/mImg/xintese.jpg" alt="">
			<!-- <div class="forthBoxItem">
				<div class="forthBoxItemLeft">
					<div class="ItemTitle">品牌理念</div>
					<div class="ItemText">秉持“中学为体、西学为用”的发展理念，<br />
						将西方科技融入东方智慧，<br />
						以植物生命能量修护肌肤功能，<br />
						用生物科技修护肌肤结构，<br />
						用科技引领护肤新体验。</div>
				</div>
			</div> -->
		</div>
		<div class="thirdBox">
			<img class="mFirst4" src="../../assets/mImg/xinlinian.jpg" alt="">
		</div>

		<div class="fifthBox">
			<!-- <img class="mFirst5" src="../../assets/xinNew3.jpg" alt=""> -->
			<!-- <div class="fifthBoxItem">
				<div class="fifthBoxItemTitle">核心技术</div>
				<div class="fifthBoxItemMain">
					<div class="mainItem1 mainItem">
						<div class="mainItemImgBox">
							<img class="mainItemImg" src="../../assets/brand/f-brandItem1.png" alt="">
						</div>
						<div class="mainItemBottomT busiz-text-ellipes1">临界植物萃取</div>
					</div>
					<div class="mainItem2 mainItem">
						<div class="mainItemImgBox">
							<img class="mainItemImg" src="../../assets/brand/f-brandItem2.png" alt="">
						</div>
						<div class="mainItemBottomT busiz-text-ellipes1">纳米技术</div>
					</div>
					<div class="mainItem2 mainItem">
						<div class="mainItemImgBox">
							<img class="mainItemImg" src="../../assets/xinqingBrand/xinjishuNew.jpg" alt="">
						</div>
						<div class="mainItemBottomT busiz-text-ellipes1">超微粒乳化技术</div>
					</div>
				</div>
			</div> -->
		</div>

		<div class="footerBoxMain">
			<div class="footerBoxMainMiddle">
				<div class="footerBoxTitle">快捷导航</div>
				<div class="bottomNavFirst bottomNav1">
					<div class="mHomeName">
						<router-link to="/m" tag="a">首页</router-link>
					</div>
					<div class="ptjjhName">
						<router-link to="/mDynamicLanshu" tag="a">菩提基金会</router-link>
					</div>
				</div>
				<div class="bottomNavFirst bottomNav2">
					<div class="mHomeName">
						<router-link to="/maboutLansu" tag="a">关于兰树</router-link>
					</div>
					<div class="ptjjhName">
						<router-link to="/mhuaibrand" tag="a">兰树品牌</router-link>
					</div>
				</div>
				<div class="bottomNavFirst bottomNav3">
					<div class="mHomeName">
						<router-link to="/mbrandLansu" tag="a">美业菩提</router-link>
					</div>
					<div class="ptjjhName">
						<router-link to="/mTrends" tag="a">兰树动态</router-link>
					</div>
				</div>
				<div class="footerBoxTitle footerBoxTitle2">联系我们</div>
				<div class="contactFirst contactFirst1">
					<div class="contactImgBox">
						<img class="contactImg" src="../../assets/mImg/emailIcon.png" alt="">
					</div>
					<div class="contactContent">
						邮箱：postermaster@lasur.com
					</div>
				</div>
				<div class="contactFirst contactFirst2">
					<div class="contactImgBox">
						<img class="contactImg" src="../../assets/mImg/phoneIcon.png" alt="">
					</div>
					<div class="contactContent">
						电话：0571-89025888
					</div>
				</div>
				<div class="contactFirst contactFirst3">
					<div class="contactImgBox">
						<img class="contactImg" src="../../assets/mImg/gpsIcon.png" alt="">
					</div>
					<div class="contactContent">
						浙江省杭州市之江东路越秀·维多利中心A座 17楼
					</div>
				</div>
			</div>
			<div class="bottomLine"></div>
			<div class="codeBoxMain">
				<div class="footerBoxHeaderLeft">
					<img class="codeImg" src="../../assets/code.png" alt="">
					<span class="codeText">兰树公众号</span>
				</div>
				<div class="footerBoxHeaderRight">
					<img class="codeImg" src="../../assets/xcxNew.jpg" alt="">
					<span class="codeText">兰树云小程序</span>
				</div>
			</div>
			<div class="footerBoxBottom">
				<div class="footerLeft">
					Copyright © 2023 兰树化妆品股份有限公司
				</div>
				<div class="footerLeft">
					<a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备20018890号-1</a><br />
					<img
						src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2022-09-13_13-29-23_21054.png" /><a
						target="_blank"
						href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33052102000740">浙公网安备
						33052102000740号</a>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
export default {
	data() {
		return {
			drawer: false,
			direction: 'ltr',
			series:[
				{img:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-08-18_13-53-56_72355.jpg'},
				{img:require('../../assets/mImg/xinNew2.jpg')},
				{img:require('../../assets/mImg/xinNew3.jpg')},
				{img:require('../../assets/mImg/xinNew4.jpg')},
			]
		}
	},
	methods: {
		handleClose(done) {
			done()
		},
		open() {
			this.drawer = true
		},
		handleOpen(key, keyPath) {
			console.log(key, keyPath);
		},
		handleCloseMenu(key, keyPath) {
			console.log(key, keyPath);
		},
		enterProducts(id) {
			this.$router.push({ path: '/mProductList', query: { brandId: id } });
		},
	}
}
</script>

<style scoped>

.seriesImg{
	width: 100%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-bottom: 8%;
	
}
.seriesImg img{
	width: 100%;
	
}

.swiperItemBox {
	/* margin-top: 2rem; */
}

.swiperItemBoxMain {
	width: 100%;
	margin: 0 auto;
	display: flex;
	align-content: space-between;
	flex-direction: row;
	flex-wrap: wrap;
	padding-bottom: 2rem;
}





.mxinBrandCo {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.mFirst {
	width: 100%;
}

.mFirstBoxMenu {
	position: absolute;
	top: 0;
	left: 0;
	z-index: 999;
}

.mFirstBoxImgMenu {
	width: 50%;
	float: left;
	position: relative;
	left: 0.5rem;
}

.mFirstBox {
	position: absolute;
	top: 15%;
	z-index: 99;
}


.mFirstBoxImgBox {
	width: 100%;
}

.mFirstBoxImg {
	width: 45%;
	float: right;
	margin-right: 10%;
}

.firstBox {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 3.5rem;
}

.secondBox {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.mSecondTitleBox {
	text-align: center;
	z-index: 99;
	color: #222222;
	font-size: 1rem;
}

.thirdBox {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	background-color: #FEFBF7;
}

.thirdBoxItem {
	width: 90%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-top: 10%;
	padding-bottom: 10%;
}

.pageTopTitle {
	font-size: 1.4rem;
	font-family: SimSun;
	color: #222222;
	line-height: 35px;
	text-align: center;
	position: relative;
	top: -1.5rem;
}

.thirdBoxItemMain {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	margin-top: 0.5rem;
}

.thirdBoxItemMainLeft {
	width: 40%;
}

.thirdBoxItemMainLeftImg {
	width: 100%;
}

.thirdBoxItemMainRight {
	width: 60%;
	display: flex;
	flex-direction: column;
}

.thirdBoxItemMainRightTop {
	width: 100%;
	display: flex;
	flex-direction: row;
}

.cavas {
	width: 3.5rem;
	height: 3.5rem;
	border-radius: 50%;
	border: solid #999999 1px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 1rem;
	font-weight: 400;
	color: #2A2A2A;
	margin-left: 0.5rem;
	position: relative;
}

.forthBox {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	

}

.thirdBoxItemMainRightTitle {
	color: #222222;
	font-size: 0.9rem;
	margin-left: 0.5rem;
	margin-top: 0.5rem;
}


.fifthBox {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	background: url(../../assets/xinNew3.jpg) no-repeat;
	background-size: 100%;
}

.forthBoxItem {
	width: 100%;
	display: flex;
	flex-direction: column;
	position: relative;
	padding-top: 10%;
	padding-bottom: 20%;
}

.forthBoxItemLeft {
	float: left;
	display: flex;
	flex-direction: column;
	margin-left: 1rem;
}

.ItemTitle {
	color: #222222;
	font-size: 1.4rem;
}

.ItemText {
	color: #333333;
	font-size: 0.9rem;
	line-height: 20px;
	margin-top: 0.5rem;
}

.fifthBoxItem {
	width: 80%;
	display: flex;
	flex-direction: column;
	align-items: center;
	position: relative;
	padding-top: 5%;
	padding-bottom: 5%;
}

.fifthBoxItemTitle {
	color: #111111;
	font-size: 1.4rem;
	position: relative;
	top: -0.8rem;
}



.footerFirstLine {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	margin: 0 auto;
	justify-content: center;
	margin-top: 1rem;
}

.footerSecondLine {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	margin: 0 auto;
	justify-content: center;
	margin-top: 0.5rem;
}

.footerItem {
	list-style: none;
}

.footerItem a {
	color: #FFFFFF;
	font-size: 0.9375rem;
	text-decoration: none;
	margin-left: 0.5rem;
}

.lastHeader {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	font-size: 0.9375em;
	color: #FFFFFF;
	line-height: 28px;
	margin-left: 1rem;
}

.lastHeader li a {
	text-decoration: none;
	font-size: 0.9375rm;
	color: #FFFFFF;
	line-height: 28px;
}

.lastHeader li {
	list-style: none;
}

.footerBoxHeader {
	width: 60%;
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin-top: 1rem;
}

.footerBoxHeaderLeft,
.footerBoxHeaderRight {
	display: -ms-flexbox;
	display: flex;
	-ms-flex-direction: column;
	flex-direction: column;
	-ms-flex-align: center;
	align-items: center;
}


.footerInfoBox {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 1rem;
}

.emailBox {
	font-size: 0.875rem;
	color: #FFFFFF;
	line-height: 20px;
}


.phoneBox {
	font-size: 0.875rem;
	color: #FFFFFF;
	line-height: 20px;
	margin-top: 0.5rem;
}

.addressBox {
	font-size: 0.875rem;
	color: #FFFFFF;
	line-height: 20px;
	margin-top: 0.5rem;
	text-align: center;
}

.footerLine {
	width: 100%;
	height: 1px;
	display: flex;
	background: #FFFFFF;
	opacity: 0.1;
	margin: 0 auto;
	align-items: center;
	margin-top: 0.5rem;
}

.footerBoxBottom {
	display: flex;
	margin: 0 auto;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	margin-top: 1rem;
}


.fifthBoxItemMain {
	width: 100%;
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-around;
	margin-top: 0.5rem;
}

.mainItem {
	width: 33.3%;
	display: flex;
	flex-direction: column;
}

.mainItemImgBox {
	width: 100%;
}

.mainItemImg {
	width: 100%;
}

.mainItemBottomT {
	text-align: center;
	line-height: 33px;
	font-size: 0.8rem;
	font-weight: 400;
	color: #2A2A2A;
	background-color: #FFFFFF;
	position: relative;
	top: -1rem;
}

.footerBoxMainMiddle {
	width: 80%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	margin-top: 1.5rem;
}

.footerBoxTitle {
	color: #FFFFFF;
	font-size: 1rem;
	font-weight: 500;
}

.bottomNavFirst {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin-top: 1rem;
}

.mHomeName a {
	color: #FFFFFF;
	opacity: 0.6;
	font-size: 0.9rem;
	text-decoration: none;
}

.ptjjhName a {
	color: #FFFFFF;
	opacity: 0.6;
	font-size: 0.9rem;
	text-decoration: none;
}

.contactFirst {
	display: flex;
	flex-direction: row;
	align-items: center;
}

.contactImgBox {
	width: 0.8rem;
}

.contactImg {
	width: 100%;
}

.contactContent {
	color: #FFFFFF;
	font-size: 0.7rem;
	opacity: 0.7;
	margin-left: 0.5rem;
}

.bottomLine {
	width: 100%;
	height: 2px;
	background: #FFFFFF;
	opacity: 0.1;
	margin-top: 1.5rem;
}

.footerBoxTitle2 {
	margin-top: 1.5rem;
}

.contactFirst1 {
	margin-top: 1rem;
}

.codeBoxMain {
	width: 50%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin: 0 auto;
	margin-top: 1.5rem;
}


.codeImg {
	width: 80%;
}

.codeText {
	font-size: 0.5em;
	color: #FFFFFF;
	line-height: 20px;
	opacity: 0.7;
	/* margin-top: 0em; */
}

.footerBoxMain {
	width: 100%;
	background-color: #FD8204;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-bottom: 1rem;
}

.footerLeft {
	text-align: center;
	font-size: 0.9em;
	color: #FFFFFF;
	line-height: 24px;
	opacity: 0.7;
}

.footerLeft a {
	text-decoration: none;
	cursor: pointer;
	color: #FFFFFF;
	opacity: 0.7;
}

.contactFirst2 {
	margin-top: 0.5rem;
}

.contactFirst3 {
	margin-top: 0.5rem;
}

.mFirst4 {
	width: 100%;
	/* position: absolute; */
}

.mFirst5 {
	width: 100%;
	position: absolute;
}

.busiz-text-ellipes1 {
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	/*! autoprefixer: off */
	-webkit-box-orient: vertical;
	/*autoprefixer: on */
}


/* 新导航栏 */
.menuBox {
	position: fixed;
	width: 100%;
	display: flex;
	top: 0;
	flex-direction: row;
	background: #FFFFFF;
	padding-top: 0.8rem;
	padding-bottom: 0.5rem;
	align-items: center;
	justify-content: space-between;
	z-index: 999;
}

.menuImgBox {
	width: 33.33%;
}

.menuImg {
	width: 17%;
	margin-left: 1rem;
}

.lansuImgBox {
	width: 40%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	margin-right: 1rem;
}

.blackBox {
	width: 33.33%;

}

.lansuImg {
	width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/mComponents/mxinBrand.vue